import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 30px;
  overflow: hidden;
  z-index: 1350;
`;
